import { useEffect } from 'react'
import { leadEmailProviderRealtime } from '@/lib/lead-email-provider-realtime'

/**
 * Hook to initialize real-time processing of new email events for lead_email_provider
 * This will automatically process new EMAIL_SENT, EMAIL_REPLY, and EMAIL_BOUNCE events
 * as they come into the obsync_dynamic_reports table
 */
export function useLeadEmailProviderRealtime() {
  useEffect(() => {
    // Initialize the real-time service
    leadEmailProviderRealtime.initialize()

    // Cleanup on unmount
    return () => {
      leadEmailProviderRealtime.stop()
    }
  }, [])

  return {
    getStatus: () => leadEmailProviderRealtime.getStatus()
  }
}
